"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataSyncProviderImpl = void 0;
var Utils_1 = require("../../../utils/Utils");
var Parse = require('parse');
var CoreServiceHelper_1 = require("./CoreServiceHelper");
var Settings_1 = require("../../Settings");
var DataSyncProviderImpl = (function () {
    function DataSyncProviderImpl(cfg) {
        var _this = this;
        this.cfg = cfg;
        this.listeners = [];
        this.log = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (true || _this.cfg.debuggable) {
                (_a = _this.cfg.logger).log.apply(_a, __spreadArray(["[".concat(_this.env, "] ").concat((0, Utils_1.getTimeString)(), " [Firebase] DataSyncProviderImpl#")], args, false));
            }
        };
        this.log('[Airabbi] DataSyncProviderImpl# created!');
    }
    DataSyncProviderImpl.prototype.init = function (env, cfg) {
        var _this = this;
        Parse.initialize('myAppId');
        Parse.serverURL = Settings_1.Settings.SERVER_CONFIG.connections.parse_server_url;
        this.env = env;
        if (cfg) {
            this.cfg = cfg;
        }
        this.realTimeConn = new Parse.LiveQueryClient({
            applicationId: 'myAppId',
            serverURL: Settings_1.Settings.SERVER_CONFIG.connections.parse_server_ws_url,
            javascriptKey: 'testKey',
        });
        this.realTimeConn.open();
        this.realTimeConn.on('open', function () {
            _this.log('real time conn created!!');
        });
        return Promise.resolve();
    };
    DataSyncProviderImpl.prototype.setDebuggable = function (debuggable) {
        if (this.cfg) {
            this.cfg.debuggable = debuggable;
        }
    };
    DataSyncProviderImpl.prototype.stopAllMonitor = function () {
    };
    DataSyncProviderImpl.prototype.projectObj = function (returnObj, key, projection) {
        if (returnObj[key]) {
            if (projection[key]) {
                returnObj = returnObj[key][projection[key]];
            }
            else {
                returnObj = returnObj[key];
            }
        }
        else {
            returnObj = null;
        }
    };
    DataSyncProviderImpl.prototype.getSubscribeResult = function (collection, filter, projection, isSingleObj) {
        var _this = this;
        var reqProjection = {};
        if (projection) {
            Object.keys(projection).forEach(function (key) {
                if (projection[key]) {
                    reqProjection["".concat(key, ".").concat(projection[key])] = true;
                }
                else {
                    reqProjection[key] = true;
                }
            });
        }
        if (isSingleObj) {
            return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
                .queryOne(collection, filter, reqProjection)
                .then(function (response) {
                var returnObj = response && response.result ? response.result : {};
                if (returnObj && projection) {
                    Object.keys(projection).forEach(function (key) {
                        returnObj = _this.projectObj(returnObj, key, projection);
                    });
                }
                return returnObj;
            });
        }
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryData(collection, filter, {}, reqProjection, '')
            .then(function (response) {
            var returnObjs = response && response.result ? response.result : [];
            if (returnObjs && projection) {
                Object.keys(projection).forEach(function (key) {
                    returnObjs = returnObjs.map(function (returnObj) {
                        returnObj = _this.projectObj(returnObj, key, projection);
                    });
                });
            }
            return returnObjs;
        });
    };
    DataSyncProviderImpl.prototype.removeRealTimeNotification = function (collection, filter) {
        var _this = this;
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .removeRealTimeNotification()
            .then(function (response) {
            if (response.status === 'success')
                _this.log('removeRealTimeNotification# delete success');
        });
    };
    DataSyncProviderImpl.prototype.subscribe = function (tag, path, listener, collection, filter, projection, isSingleObj) {
        var _this = this;
        var dataSyncNode = {
            tag: tag,
            path: path,
            collection: collection,
            filter: filter,
            listener: listener,
        };
        this.log('subscribe  collection:', collection, 'filter: ', filter);
        var query = new Parse.Query('realTimeNotification');
        var queryFilter = {};
        query.equalTo('collection', collection);
        for (var index in filter) {
            queryFilter["filter.".concat(index)] = filter[index];
        }
        for (var index in queryFilter) {
            query.equalTo(index, queryFilter[index]);
        }
        if (collection === 'isUpdateCode') {
            var subscription_1 = this.realTimeConn.subscribe(query);
            subscription_1.on('create', function (obj) {
                var returnObj = obj.toJSON();
                listener.onChanged(returnObj);
            });
            listener.onChanged({ isInit: true });
            this.listeners.push({
                tag: tag,
                path: path,
                collection: collection,
                filter: filter,
                subscription: subscription_1,
            });
            return Promise.resolve(dataSyncNode);
        }
        this.log('realtime#subscribe', query);
        var subscription = this.realTimeConn.subscribe(query);
        subscription.on('create', function (obj) {
            _this.log('realtime#create', obj);
            _this.getSubscribeResult(collection, filter, projection, isSingleObj).then(function (obj) {
                listener.onChanged(obj);
            });
        });
        this.getSubscribeResult(collection, filter, projection, isSingleObj).then(function (obj) {
            listener.onChanged(obj);
        });
        this.listeners.push({
            tag: tag,
            path: path,
            collection: collection,
            filter: filter,
            subscription: subscription,
        });
        this.log('#subscribe#DataSyncNode List:', this.listeners);
        return Promise.resolve(dataSyncNode);
    };
    DataSyncProviderImpl.prototype.unsubscribe = function (node) {
        var _this = this;
        this.log('unsubscribe#node:', node);
        if (!node) {
            return Promise.resolve();
        }
        this.log('unsubscribe# DataSyncNode count - before:', this.listeners.length);
        var filteredList = this.listeners.filter(function (obj) { return obj.tag === node.tag; });
        if (!filteredList || filteredList.length === 0) {
            this.log('unsubscribe#node not found for tag:', node.tag);
            return Promise.resolve();
        }
        filteredList.forEach(function (obj) {
            _this.realTimeConn.unsubscribe(obj.subscription);
        });
        filteredList.forEach(function (dataNote) {
            var index = _this.listeners.findIndex(function (dataNode) { return dataNode.tag === node.tag; });
            if (index !== -1) {
                _this.listeners.splice(index, 1);
            }
        });
        this.log('unsubscribe# remove:', filteredList);
        this.log('unsubscribe# DataSyncNode count:', this.listeners.length);
        return Promise.resolve();
    };
    DataSyncProviderImpl.prototype.clear = function () {
        var _this = this;
        var tmp = this.listeners;
        tmp.forEach(function (obj) {
            _this.unsubscribe(obj)
                .then(function () {
                _this.log('clear#unsubscribe#:', obj);
            })
                .catch(function (err) {
                _this.log('clear#unsubscribe#:', err);
            });
        });
        this.listeners = [];
        return Promise.resolve();
    };
    DataSyncProviderImpl.prototype.list = function () {
        return Promise.resolve(this.listeners);
    };
    return DataSyncProviderImpl;
}());
exports.DataSyncProviderImpl = DataSyncProviderImpl;
//# sourceMappingURL=DataSyncProviderImpl.js.map